<template>
  <div id="ad-banner"></div>
</template>

<script>
export default {
  name: 'AdBanner',
  mounted() {
    // 加载外部脚本
    const script = document.createElement('script')
    script.src = '//acscdn.com/script/aclib.js' // 替换为实际脚本地址
    script.type = 'text/javascript'
    script.onload = () => {
      // 脚本加载完成后执行
      if (window.aclib) {
        window.aclib.runBanner({
          zoneId: '11006402'
        })
      }
    }
    document.body.appendChild(script)
  },
  beforeUnmount() {
    // 清理脚本，避免内存泄漏
    const script = document.querySelector('script[src="//acscdn.com/script/aclib.js"]')
    if (script) {
      script.remove()
    }
  }
}
</script>